var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"options":_vm.options,"reduce":function (option) { return option.value; },"value":_vm.value,"placeholder":_vm.$t('selects.areaSelectPlaceholder'),"multiple":false,"disabled":_vm.disabled},on:{"input":_vm.setValue}})}
var staticRenderFns = []

export { render, staticRenderFns }